function scrolledFraction(scrollableDistance, scrolledAmount) {
  let fraction;
  if (scrolledAmount > scrollableDistance) {
    fraction = 0;
  } else if (scrolledAmount === 0) {
    fraction = 1;
  } else {
    fraction = (scrollableDistance - scrolledAmount) / scrollableDistance;
  }
  return fraction;
}

function scrollToTop(ref) {
  ref.current.scrollIntoView(true);
}

function scrollToBottom(ref) {
  ref.current.scrollTop = ref.current.scrollHeight;
}

function asyncScrollToTop({ behavior = 'smooth', ref } = {}) {
  const el = ref?.current || window;

  el.scrollTo({ top: 0, behavior });

  return new Promise((resolve, reject) => {
    const failed = setTimeout(() => {
      reject();
    }, 3000);

    const scrollHandler = () => {
      if (!(el.scrollTop || el.scrollY)) {
        el.removeEventListener('scroll', scrollHandler);
        clearTimeout(failed);
        resolve();
      }
    };

    if (!(el.scrollTop || el.scrollY)) {
      clearTimeout(failed);
      resolve();
    } else {
      el.addEventListener('scroll', scrollHandler);
    }
  });
}

export { scrolledFraction, scrollToTop, scrollToBottom, asyncScrollToTop };
